<div [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <div *ngFor="let comp of restaurantComponent">
    <ng-container [ngSwitch]="comp.type">
      <app-hero-with-one-image
        *ngSwitchCase="'hero-with-one-image'"
        [data]="comp.details"
      ></app-hero-with-one-image>
      <app-our-works *ngSwitchCase="'our-works'" [data]="comp.details" />
      <app-title-with-button
        *ngSwitchCase="'title-with-button'"
        [data]="comp.details"
      />
      <app-hero-section
        *ngSwitchCase="'hero'"
        [data]="comp.details"
        [language]="language"
      ></app-hero-section>
      <div *ngSwitchCase="'app-text-with-one-image'">
        <app-text-with-one-image
          [data]="comp.details"
        ></app-text-with-one-image>
      </div>
      <app-hero-carousel
        *ngSwitchCase="'hero-carosel'"
        [data]="comp.details"
        [language]="language"
      >
      </app-hero-carousel>
      <app-hero-image-text
        *ngSwitchCase="'hero-image-with-text'"
        [data]="comp.details"
      ></app-hero-image-text>
      <div class="" *ngSwitchCase="'grid-without-frame'">
        <app-grid-cards-without-frame
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-grid-cards-without-frame>
      </div>
      <app-hero-text-with-img
        *ngSwitchCase="'hero-text-with-img'"
        [data]="comp.details"
      />
      <div class="services" *ngSwitchCase="'grid-with-frame'">
        <app-grid-cards-with-frame
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-grid-cards-with-frame>
      </div>
      <div *ngSwitchCase="'multi-text-with-image'">
        <app-multi-text-with-image
          [data]="comp.details"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-multi-text-with-image>
      </div>
      <div class="mx-3 mx-md-5" *ngSwitchCase="'clients'">
        <app-our-client
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-our-client>
      </div>
      <div *ngSwitchCase="'gallery'">
        <app-gallery
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-gallery>
      </div>
      <div class="" *ngSwitchCase="'projects'">
        <app-our-projects
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-our-projects>
      </div>

      <div class="mx-3 mx-md-5" *ngSwitchCase="'counter'">
        <app-work-counter
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-work-counter>
      </div>
      <div class="mx-3 mx-md-5" *ngSwitchCase="'text-with-image'">
        <app-text-with-image
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-text-with-image>
      </div>
      <div class="mx-3 mx-md-5" *ngSwitchCase="'image-with-text'">
        <app-image-with-text
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-image-with-text>
      </div>
      <div class="mx-3 mx-md-5" *ngSwitchCase="'multi-images-with-text'">
        <app-multi-images-with-text
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-multi-images-with-text>
      </div>
      <div class="mx-3 mx-md-5" *ngSwitchCase="'app-contact-form'">
        <app-contact-form
        ></app-contact-form>
      </div>
            <div class="mx-3 mx-md-5" *ngSwitchCase="'app-bordered-icon-card'">
        <app-bordered-icon-card
        [data]="comp.details"
        ></app-bordered-icon-card>
      </div>
       <div *ngSwitchCase="'app-one-image-with-text'">
        <app-one-image-with-text
          [data]="comp.details"
        ></app-one-image-with-text>
      </div>
      <div class="mx-3 mx-md-5" *ngSwitchCase="'app-vertical-steps'">
        <app-vertical-steps
        [data]="comp.details"
        ></app-vertical-steps>
      </div>
      <div class="" *ngSwitchCase="'app-grid-cards-without-frame'">
        <app-grid-cards-without-frame
          [data]="comp"
          [language]="language"
          [fileName]="comp.fileName"
        ></app-grid-cards-without-frame>
      </div>
      
    </ng-container>
  </div>
</div>
